
/**
 * TopLink (Back to Top) for lbbw-am.de
 *
 * @author Florian Gutwald
 * Converted to Plain JS for Rollup
 */

/**
 * Initialize the top link functionality
 */
export function initTopLink() {
  const topLink = document.getElementById('toplink');

  if (!topLink) {
    console.warn('TopLink: #toplink element not found');
    return;
  }

  // Initially hide the top link
  topLink.classList.remove('show');

  // Click handler - scroll to top
  topLink.addEventListener('click', (event) => {
    event.preventDefault();

    // Smooth scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    return false;
  });

  // Scroll handler - show/hide based on scroll position
  let scrollTimeout;

  window.addEventListener('scroll', () => {
    // Debounce scroll event for better performance
    clearTimeout(scrollTimeout);

    scrollTimeout = setTimeout(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Show if scrolled more than 100px or if browser doesn't support maxHeight
      if (scrollTop > 100 || typeof document.body.style.maxHeight === 'undefined') {
        topLink.classList.add('show');
      } else {
        topLink.classList.remove('show');
      }
    }, 10);
  });
}

export default initTopLink;